<template>
  <div id="app" class="app" :class="'app-' + $route.meta.class">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, MessageBox, Message } from "element-ui";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

Vue.use(Icon);

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;

export default {
  name: "main-app",
  components: {
    Header,
    Footer,
  }
};
</script>

<style lang="scss">
@import "./assets/style/reset.css";
@import "./assets/style/common.scss";

#app {
  color: #333;
  //   min-width: 980px;
}

a {
  color: #333;
  text-decoration: none;

  &:hover {
    color: #0055a5;
    text-decoration: underline;
  }
}

.desktop {
    .app {
        min-width: 1040px
    }
}

</style>
